<template>
    <form
        action=""
        class="picker-datetime-modal"
        @submit.prevent="handle_schedule_email"
    >
        <div class="modal-card" style="width: auto">
            <header class="modal-card-head">
                <p class="modal-card-title">Pick date & time</p>
                <o-button
                    class="close"
                    rounded
                    size="is-small"
                   @click="$parent.$parent.$emit('update:active', false)"
                >
                    <o-icon icon="close" pack="mdi" />
                </o-button>
            </header>
            <section class="modal-card-body">
                <flat-pickr
                    :config="config"
                    class="input"
                    placeholder=""
                    v-model="date"
                >
                </flat-pickr>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">
                    Cancel
                </button>
                <button class="button is-primary">Schedule send</button>
            </footer>
        </div>
    </form>
</template>

<script>
export default {
    computed: {
    },
    data() {
        return {
            config: {
                altFormat: "F j, Y h:i K",
                altInput: true,
                dateFormat: "Y-m-d H:i:S",
                enable: [
                    function (date) {
                        const now = new Date()
                        return (date.getTime() >= now.getTime())
                    }
                ],
                enableTime: true,
                inline: true,
            },
            date: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
        }
    },
    methods: {
        handle_schedule_email() {
            this.$emit('send_scheduled', this.date)
        },
    },
    mounted() {
    },
}
</script>

<style>
.picker-datetime-modal .modal-card-head {
  background: #fff;
  border: none;
  padding-bottom: 8px;
  padding: 20px 16px 8px 20px; }
.picker-datetime-modal .modal-card-head .modal-card-title {
  font-size: 22px; }
.picker-datetime-modal .modal-card-head .close {
  background: transparent;
  border: none;
  border-radius: 50%;
  box-shadow: none;
  font-size: 17px;
  height: 40px;
  width: 40px; }
.picker-datetime-modal .modal-card-head .close:hover {
  background: #000017; }

.picker-datetime-modal .modal-card-body {
  padding-bottom: 0; }
.picker-datetime-modal .modal-card-body .dropdown-content {
  box-shadow: none; }

.picker-datetime-modal .modal-card-foot {
  background-color: #fff;
  display: flex;
  justify-content: flex-end; }
.picker-datetime-modal .modal-card-foot > button:last-child {
  background-color: #1a73e8;
  border-radius: 4px;
  color: #fff;
  display: inline-flex; }
.picker-datetime-modal .modal-card-foot > button:last-child:hover {
  box-shadow: 0 1px 2px 0 rgba(26, 115, 232, 0.45), 0 1px 3px 1px rgba(26, 115, 232, 0.3);
  background-color: #297be6;
  outline: 1px solid transparent; }

</style>